/* tslint:disable */
/* eslint-disable */
/**
 * cellera-backend API spec
 * Backend Service for Cellera | [swagger.json](cellera/swagger.json)
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface CountryDto
 */
export interface CountryDto {
    /**
     * Country ID
     * @type {number}
     * @memberof CountryDto
     */
    id: number;
    /**
     * Country name
     * @type {string}
     * @memberof CountryDto
     */
    name: string;
    /**
     * ISO2 country code
     * @type {string}
     * @memberof CountryDto
     */
    iso2: string;
    /**
     * ISO3 country code
     * @type {string}
     * @memberof CountryDto
     */
    iso3: string;
    /**
     * Country phone code
     * @type {string}
     * @memberof CountryDto
     */
    phonecode: string;
    /**
     * Country capital
     * @type {string}
     * @memberof CountryDto
     */
    capital: string;
    /**
     * Country currency
     * @type {string}
     * @memberof CountryDto
     */
    currency: string;
    /**
     * Country native name
     * @type {string}
     * @memberof CountryDto
     */
    _native: string;
    /**
     * Country emoji
     * @type {string}
     * @memberof CountryDto
     */
    emoji: string;
}

/**
 * Check if a given object implements the CountryDto interface.
 */
export function instanceOfCountryDto(value: object): value is CountryDto {
    if (!('id' in value) || value['id'] === undefined) return false;
    if (!('name' in value) || value['name'] === undefined) return false;
    if (!('iso2' in value) || value['iso2'] === undefined) return false;
    if (!('iso3' in value) || value['iso3'] === undefined) return false;
    if (!('phonecode' in value) || value['phonecode'] === undefined) return false;
    if (!('capital' in value) || value['capital'] === undefined) return false;
    if (!('currency' in value) || value['currency'] === undefined) return false;
    if (!('_native' in value) || value['_native'] === undefined) return false;
    if (!('emoji' in value) || value['emoji'] === undefined) return false;
    return true;
}

export function CountryDtoFromJSON(json: any): CountryDto {
    return CountryDtoFromJSONTyped(json, false);
}

export function CountryDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): CountryDto {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'name': json['name'],
        'iso2': json['iso2'],
        'iso3': json['iso3'],
        'phonecode': json['phonecode'],
        'capital': json['capital'],
        'currency': json['currency'],
        '_native': json['native'],
        'emoji': json['emoji'],
    };
}

export function CountryDtoToJSON(json: any): CountryDto {
    return CountryDtoToJSONTyped(json, false);
}

export function CountryDtoToJSONTyped(value?: CountryDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'name': value['name'],
        'iso2': value['iso2'],
        'iso3': value['iso3'],
        'phonecode': value['phonecode'],
        'capital': value['capital'],
        'currency': value['currency'],
        'native': value['_native'],
        'emoji': value['emoji'],
    };
}

